import { get } from "../Config";


export function GetAllBrand() {
  return get({ url: `/api/impact/v1/allBrand` });
}

export function GetAllBranch({ params }) {
  return get({ url: `/api/impact/v1/searchBranchBrand`, params });
}

export function GetBrandIdByName({ params }) {
  return get({ url: `/api/impact/v1/brandIdByName`, params });
}